export default __webpack_public_path__ + "static/media/close-icon.6feb9a64.svg";